<template>
  <div class="page_container storageManeagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >基础设置&客服帮助</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/storageIndex/sManageIndex' }"
          >仓储资源管理</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{ path: `/storageIndex/sManageTwo` }"
          >{{ shelfItem.whname }}</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ shelfItemChild.whname }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <p class="flex-rowl" @click="handleAddOne">
            <i class="iconfont icon-xinzeng"></i> 新增
          </p>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="shelfNumData.length > 0">
          <div class="item_wrap" v-for="item in shelfNumData" :key="item.id">
            <div class="item_main_wrap flex-between">
              <div class="content_wrap">
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      层名称：<span>{{ item.whname }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="edit_group flex-rowr">
                <div class="editBtn" @click="handlEdit(item.id)">
                  修改层名称→
                </div>
                <div class="editBtn" @click="handleGo(item.id)">管理该层→</div>
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="尚未添加货架"
          v-if="!loading && shelfNumData.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->

    <!-- 弹窗 start -->
    <el-dialog title="层名称" :visible.sync="isShow" width="30%">
      <div class="input_box">
        <el-input v-model="name" placeholder="输入层名称"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="handleQuery">{{
          isEdit ? "保存" : "确 认"
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 弹窗 end -->
  </div>
</template>

<script>
import {
  getMenuAuthTwo,
  getWearhouseDetail,
  addWearhouseHorizon,
  editWearhouseHorizon,
  encryptstringadd,
  encryptstringview,
} from "../../api/api";
import { mapState } from "vuex";
export default {
  name: "sManageThree",
  data() {
    return {
      qyid: 0,
      editId: "",

      parentid: "",
      shelfId: "",

      isShow: false, // 弹窗是否显示
      isEdit: false, // 弹窗是否编辑
      shelfItem: "",
      shelfItemChild: "",
      shelfNumData: [],
      name: "", // 仓库名称

      loading: false,
      listData: [],
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    this.getMenuAuthTwo();

    let { routerList, OPENID, USERINFO, menuItem } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.qyid = USERINFO.qy.id;
    } else {
      this.qyid = 0;
    }
    this.roleId = USERINFO.roleid;
    this.menuItem = menuItem;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, parentid } = JSON.parse(res.jsondata);
        this.parentid = parentid;
        this.shelfId = id;
        this.initData();
      } else {
        this.$router.back();
      }
    },

    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    initData() {
      this.loading = true;
      getWearhouseDetail({ id: this.parentid }).then((res) => {
        if (res.length > 0) {
          let dataNew = res[0];
          this.shelfItem = dataNew;
          // 货架
          let filterData = dataNew.childs2.filter((v) => v.id == this.shelfId);
          if (filterData.length > 0) {
            this.shelfItemChild = filterData[0];
            this.shelfNumData = filterData[0].childs3;
          }
        }
        this.loading = false;
      });
    },

    // 新增仓库
    handleAddOne() {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$message.warning("暂无权限");
        return;
      }
      this.name = "";
      this.isShow = true;
      this.isEdit = false;
    },
    // 编辑仓库名
    handlEdit(id) {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$message.warning("暂无权限");
        return;
      }
      let { shelfNumData } = this;
      let filter = shelfNumData.filter((v) => v.id == id);
      this.name = filter[0].whname;
      this.editId = id;
      this.isShow = true;
      this.isEdit = true;
    },

    // 确认
    handleQuery() {
      let { name, isEdit, parentid, shelfId, qyid } = this;
      console.log(parentid, qyid, "=======parentid");
      if (name === "") {
        this.$message.warning("请输入货架名称");
        return;
      }
      if (!isEdit) {
        let params = {
          Method: "Warehouse3add",
          parentid: shelfId,
          // parentid: parentid,
          whname: name,
          isuse: true,
          qyid: qyid,
          openid: this.$store.state.OPENID,
        };
        this.loading = true;
        addWearhouseHorizon(params).then((res) => {
          if (res.result) {
            this.loading = false;
            this.isShow = false;
            this.initData();
            // setTimeout(() => {
            //   this.initData(parentid);
            //   this.$toast.success(res.message);
            //   Toast.clear();
            //   this.isShow = true;
            // }, 1000);
          } else {
            this.loading = false;
            this.$message.error(res.message || "提交失败，请稍后重试！");
            this.isShow = false;
          }
        });
      } else {
        let params = {
          Method: "Warehouse3edit",
          id: this.editId,
          parentid: shelfId,
          // parentid: parentid,
          whname: name,
          isuse: true,
          qyid: qyid,
          openid: this.$store.state.OPENID,
        };
        this.loading = true;
        editWearhouseHorizon(params).then((res) => {
          if (res.result) {
            this.loading = false;
            this.isShow = false;
            this.initData();
            // setTimeout(() => {
            //   this.initData(parentid);
            //   this.$toast.success(res.Message);
            //   Toast.clear();
            //   this.isShow = true;
            // }, 1000);
          } else {
            this.loading = false;
            this.$message.error(res.message || "提交失败，请稍后重试！");
            this.isShow = false;
          }
        });
      }
    },

    // 返回
    handleReturn() {
      history.back();
    },

    handleGo(id) {
      let { parentid, shelfId } = this;
      // this.$router.push(
      //   `/storageIndex/sManageFour/${parentid}/${shelfId}/${id}`
      // );
      this.encryptstringadd("sManageFour", { parentid, shelfId, id });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.storageManeagePage {
  .item_main_wrap {
    align-items: center;
  }
}
</style>